import React from 'react';
import { ISecureImageProps } from '../../models/components/secureImage';
import { Common } from '../../core/common';
import { Log } from 'ng2-logger';

let _common: Common;
const _logger = Log.create('SecureImage.tsx');

export class SecureImage extends React.Component<ISecureImageProps, any> {
    _imgType: string = '';

    public constructor(props: ISecureImageProps) {
        super(props);
        _common = new Common();
        this.state = { source: '', localUrl: '' };

        if (!this.props.imgType && this.props.imageUrl) {
            if (this.props.imageUrl.indexOf('/avatar/') > -1) {
                this._imgType = 'avatar';
            } else if (this.props.imageUrl.indexOf('/courselogo/') > -1) {
                this._imgType = 'course';
            } else {
                // tslint:disable-next-line: no-floating-promises
                _common.GetImageUrl(this.props.imageUrl).then((url: any) => {
                    this.setState({ localUrl: url });
                });
            }
        } else if (this.props.imgType) {
            this._imgType = this.props.imgType;
        }
    }

    componentDidUpdate(prevProps: Readonly<ISecureImageProps>, prevState: Readonly<any>, snapshot?: any): void {
        if (prevProps.imageUrl != this.props.imageUrl) {
            _common.GetImageUrl(this.props.imageUrl).then((url: any) => {
                this.setState({ localUrl: url });
            });
        }
    }

    onClick = (evt: any) => {
        if (typeof this.props.onClick === 'function') {
            this.props.onClick(evt);
        }
    }

    public render() {
        return <img
            style={this.props.style}
            src={this.state.localUrl ? this.state.localUrl : this.props.imageUrl}
            className={this.props.class}
            width={this.props.width}
            height={this.props.height}
            onError={typeof this.props.onError === 'function' ? this.props.onError : _common.OnErrorImageSrc}
            data-imgtype={this._imgType}
            onClick={this.onClick}
        />;
    }

}
